<template>
    <div>
        <div class="panel mb-0">
            <div class="panel-hdr d-block pt-4 p-3">
                <div class="ml-auto text-right mb-3">
                    <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                        :data="exportData"
                        :fields="exportFields"
                        :header="exportHeaders"
                        type="csv"
                        :escapeCsv="false"
                        :name="exportFileName">
                        <span>CSV</span>
                    </exportCSV>
                    <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                    <span class="mr-3">PDF</span>
                    <i class="arrow-down fas fa-angle-down"></i> 
                </button> -->
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-4 align-items-center justify-content-start">
                        <div class="dataTables_filter mb-2">
                            <label class="d-flex mb-0">
                                <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
                                    :placeholder="$t('label.search')" v-model="searchMember" @keypress.enter="filterSearch">
                                <button
                                    class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
                                    @click="filterSearch()">
                                    <i class="fas fa-search"></i>
                                </button>
                            </label>
                        </div>
                    </div>
                    <div v-show="selectedTabView == 'active'" class="col-sm-12 col-md-4 mb-2">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0">
                                        <i class="fas fa-calendar-check"></i>
                                    </label>
                                    <multiselect :value="selectedVisit" label="text" track-by="id" :options="lastVisits" :searchable="false"
                                        :show-labels="false" openDirection="below" @select="filterLastVisit"></multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2 col-sm-12 col-md-4">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0">
                                        <i class="fas fa-birthday-cake"></i>
                                    </label>
                                    <multiselect :value="selectedBday" label="text" track-by="id" :options="birthdays" :searchable="false"
                                        :show-labels="false" openDirection="below" @select="filterBirthday"></multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <ul class="nav nav-tabs">
                        <li class="nav-item" v-for="vipTab in $i18n.messages[$i18n.locale].tab.vipTabs" :key="vipTab.id">
                            <a :class="{ 'active': selectedVip == vipTab.id }" class="nav-link"
                                @click="filterVip(vipTab.id)">{{ vipTab.text }}</a>
                        </li>
                    </ul> -->
                </div>
                <div class="row">
                    <div class="mt-3 col-md-6 col-lg-6 col-xl-4 d-flex flex-column">
                        <b-button-group size="sm">
                            <b-button
                                v-for="vipTab of vipTabs"
                                :key="'membershipTab' + vipTab.id"
                                variant="outline-primary"
                                :class="selectedVip === vipTab.id ? 'active' : ''"
                                @click="selectedVip = vipTab.id">
                                {{ vipTab.text }}
                            </b-button>
                        </b-button-group>
                    </div>
                </div>
                <br>
                <a class="link text-primary" @click="clearFilter">{{ $t('button_link.clear_filter') }}</a>
            </div>
            <div class="panel-container">
                <div class="panel-content">
                    <div v-if="showSpinner" class="d-flex justify-content-center mt-3 mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div class="panel-tag mt-3" v-if="!showSpinner && totalEntries == 0">{{ $t('table.no_records') }}</div>
                    <div class="dataTables_wrapper dt-bootstrap4" v-if="!showSpinner && totalEntries != 0">
                        <div v-if="showPagination" class="row justify-content-end mt-2">
                            <div class="col-auto pt-2">
                                <span>{{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, }) }}</span>
                            </div>
                            <div class="col-auto">
                                <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
                                    @input="handlePagination"></b-pagination>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 overflow-auto">
                                <b-table striped hover :fields="fields" :items="memberLists" responsive>
                                    <template #cell(index)="data">
                                        {{ data.index + startPage }}
                                    </template>
                                    <template #cell(img)="data">
                                        <img class="profile-image-md rounded-circle"
                                            :src="data.item.icon != '' ? getMemberImage(data.item.icon) : require('@/assets/image/icon/profile.png')" />
                                    </template>
                                    <template #cell(name)="data">
                                        <div class="row w-100 h-100 hoverColumm" @click="onMemberDetailClick(data.item)">
                                            <div class="col">
                                                <div class="font-weight-bold">{{ data.item.name }}</div>
                                                <div class="align-middle">
                                                    <span class="badge badge-pill badge-success"><i class="fas fa-phone"></i></span>
                                                    {{ data.item.mobile }}
                                                </div>
                                            </div>
                                            <div class="col-auto">
                                                <a>
                                                    <b-icon variant="primary" icon="pencil"></b-icon>
                                                </a>
                                            </div>
                                        </div>
                                    </template>
                                    <template #cell(lastVisit)="data">
                                        {{ getMemberLastVisit(data.item.lastSale) }}
                                    </template>
                                    <template #cell(bday)="data">
                                        {{ getMemberDob(data.item.dob) }}
                                    </template>
                                    <template #cell(membership)="data">
                                        <h6 v-if="data.item.vip == '0' && data.item.vvip == '0' && data.item.vvvip == '0'">
                                            <span class="badge border border-secondary text-secondary fw-400">N/A</span>
                                        </h6>
                                        <h6 class="d-inline-block mr-2" v-if="data.item.vip != '0'">
                                            <span class="badge badge-primary">{{ vipTabs[1].text }}</span>
                                        </h6>
                                        <h6 class="d-inline-block mr-2" v-if="data.item.vvip != '0'">
                                            <span class="badge badge-danger">{{ vipTabs[2].text }}</span>
                                        </h6>
                                        <h6 class="d-inline-block mr-2" v-if="data.item.vvvip != '0'">
                                            <span class="badge badge-warning">{{ vipTabs[3].text }}</span>
                                        </h6>
                                    </template>
                                    <template #cell(gallery)="data">
                                        <a class="link text-primary" :title="$t('button_link.view_update', { 'item': $t('table.header.gallery') })"
                                            @click="editGallery(data.item)">
                                            <i class="fal fa-images fs-xl"></i>
                                        </a>
                                    </template>
                                    <template #cell(hiddenDate)="data">
                                        {{ getMemberDateTime(data.item.hideDate) }}
                                    </template>
                                    <template #cell(deleteDate)="data">
                                        {{ getMemberDateTime(data.item.deleteDate) }}
                                    </template>
                                    <template #cell(outlet)="data">
                                        {{ data.item }}
                                    </template>
                                    <template #cell(memberName)="data">
                                        {{ data.item.name }}
                                    </template>
                                    <template #cell(memberContact)="data">
                                        {{ data.item.mobile }}
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <memberGallery ref="memberGallery"></memberGallery>

        <div :class="{ 'show': memberDetailModal }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">
                            Edit Customer Details
                        </h5>
                        <button type="button" class="close" @click="memberDetailModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg w-100">
                        <div class="form-group">
                            <label class="form-label">Name</label>
                            <div class="input-group bg-white shadow-inset-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text bg-transparent border-right-0">
                                        <i class="fas fa-user-circle"></i>
                                    </span>
                                </div>
                                <input type="text" class="form-control bg-transparent pl-3" v-model="memberDetail.name" @keyup="onMemberDetailNameChange">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Mobile Number</label>
                            <div class="input-group bg-white shadow-inset-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text bg-transparent border-right-0">
                                        <i class="fas fa-phone-alt"></i>
                                    </span>
                                </div>
                                <input type="text" class="form-control bg-transparent pl-3" v-model="memberDetail.mobile"
                                    @keyup="onMemberDetailPhoneChange">
                            </div>
                            <div id="err" class="error-validation"></div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="help-block fs-md">
                                <p>{{ $t('message.contact_validation.notes') }}:</p>
                                <ul>
                                    <li>{{ $t('message.contact_validation.my') }} 601x xxx xxxx</li>
                                    <li>{{ $t('message.contact_validation.sg') }} 65x xxx xxxx</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" style="display: block;">
                        <button
                            type="button"
                            class="btn btn-danger waves-effect waves-themed"
                            style="float: left;"
                            @click="confirmDeleteMember">
                            Delete
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary waves-effect waves-themed"
                            style="float: right;"
                            @click="onMemberDetailModalSave"
                            :disabled="memberDetailDisableSave">
                            Save
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary waves-effect waves-themed"
                            style="float: right;"
                            @click="memberDetailModal = false">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MemberGallery from './Member_Gallery'
import moment from 'moment'
import { handleSessionExpired, setReturnData, getMemberMap } from './../../../../assets/js/dashboard/dashboard.js'
import { all } from 'q'
import { contactValidation } from './../../../../assets/js/dashboard/utilities'

export default {
    name: 'memberList',
    components: {
        MemberGallery
    },
    data() {
        return {
            selectedTabView: "active",
            searchMember: "",
            selectedVisit: {},
            selectedBday: {},
            selectedVip: 'all',
            
            field: [],

            vipTabs: [],
            showSpinner: false,
            showPagination: true,

            memberFiltered: [],
            memberLists: [],

            currentPage: 1,
            totalEntries: 0,
            totalPage: 0,
            startPage: 1,
            endPage: 0,
            perPage: 100,

            exportHeaders: [],
            exportData: [],
            exportFields: {},
            exportFileName: "",
            memberExportData: [],

            memberDetailModal: false,
            memberDetailDisableSave: true,
            memberDetail: {},
        }
    },
    computed: {
        lastVisits() {
            return [
                { id: 'all', text: this.$i18n.t('member.lastVisits.all') },
                { id: 'one', text: this.$i18n.t('member.lastVisits.one') },
                { id: 'three', text: this.$i18n.t('member.lastVisits.three') },
                { id: 'six', text: this.$i18n.t('member.lastVisits.six') },
                { id: 'more', text: this.$i18n.t('member.lastVisits.more') }
            ]
        },
        birthdays() {
            return [
                { id: 'all', text: this.$i18n.t('member.birthdays.all') },
                { id: 'today', text: this.$i18n.t('member.birthdays.today') },
                { id: 'last', text: this.$i18n.t('member.birthdays.last') },
                { id: 'this', text: this.$i18n.t('member.birthdays.this') },
                { id: 'next', text: this.$i18n.t('member.birthdays.next') }
            ]
        },
    },
    watch: {
        "$i18n.locale"(val) {
            if (Array.isArray(this.selectedBday)) {
                this.selectedBday = this.selectedBday[0]
            }
            if (Array.isArray(this.selectedVisit)) {
                this.selectedVisit = this.selectedVisit[0]
            }
            var b = Object.assign({}, this.selectedBday)
            var v = Object.assign({}, this.selectedVisit)

            this.selectedVisit = this.lastVisits.filter(obj => obj.id == v.id)
            this.selectedBday = this.birthdays.filter(obj => obj.id == b.id)

            this.setExportData(this.memberExportData)
        },
        selectedVip(val) {
            this.page = 0;
            this.currentPage = 1;
            this.selectedVip = val;
            this.loadMemberList();
        },
    },
    methods: {
        getMemberImage(img) {
            return img;
        },
        getMemberDob(dob) {
            if (!dob || dob == '0000-00-00') {
                return '-'
            }

            let temp = moment(dob, 'YYYY-MM-DD')
            if (!temp.isValid()) {
                return '-'
            }

            return temp.format('DD/MM/YYYY')
        },
        getMemberLastVisit(lastSale) {
            if (!lastSale || !lastSale.salesDate) {
                return '-'
            }

            let temp = moment.unix(lastSale.salesDate)
            return temp.format('DD/MM/YYYY')
        },
        getMemberDateTime(date) {
            let temp = moment.unix(date)
            if (!temp.isValid()) {
                return '-'
            }
            return temp.format('DD/MM/YYYY HH:mm:ss')
        },

        clearFilter() {
            this.searchMember = ""
            this.selectedVisit = this.lastVisits[0];
            this.selectedBday = this.birthdays[0];
            this.selectedVip = "all"
            this.loadMemberList();
        },
        filterMemberByView(tab) {
            this.page = 0;
            this.selectedTabView = tab;
            this.clearFilter()
        },
        filterSearch() {
            this.page = 0;
            this.currentPage = 1;
            this.loadMemberList();
        },
        filterVip(id) {
            this.page = 0;
            this.currentPage = 1;
            this.selectedVip = id;
            this.loadMemberList();
        },
        filterLastVisit(item) {
            this.page = 0;
            this.currentPage = 1;
            this.selectedVisit = item;
            this.loadMemberList();
        },
        filterBirthday(item) {
            this.page = 0;
            this.currentPage = 1;
            this.selectedBday = item
            this.loadMemberList();
        },

        handlePagination(pg) {
            this.startPage = ((this.currentPage - 1) * 100) + 1
            this.endPage = this.startPage + 99
            this.memberLists = this.memberFiltered.slice(this.startPage - 1, this.endPage)
            this.endPage = this.startPage + this.memberLists.length - 1
            //document.getElementById('btnToTop').click(); 
        },

        async getMembershipTags() {
            let $vm = this

            var init = ["vip", "vvip", "vvvip"];
            $vm.vipTabs.push({ id: "all", text: "All" });
            await $vm.$axios({
                method: 'get',
                url: this.$api.MEMBER_CONFIGURE,
                baseURL: this.$axios.defaults.baseURL,
                headers: { token: $vm.$session.get('token') }
            })
                .then(function (response) {
                    var results = response.data.vip;

                    for (var i = 0; i < results.length; i++) {
                        $vm.vipTabs.push({ id: init[i], text: results[i] });
                        $vm.selectedVip = $vm.vipTabs[0].id
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        async loadMemberList() {
            this.showSpinner = true
            this.loadMemberListImpl()
        },

        async loadMemberListImpl() {
            let memberMap = await getMemberMap(this)
            console.log(Object.keys(memberMap).length)
            let member = []

            let active = []
            let deleted = []
            let hidden = []

            for (let index in memberMap) {
                let record = memberMap[index]
                member.push(record)

                if (this.filterMember(record)) {
                    continue
                }

                if (!record['deleteDate'] && !record['hideDate']) {
                    active.push(record)
                }

                if (record['deleteDate']) {
                    deleted.push(record)
                }

                if (record['hideDate']) {
                    hidden.push(record)
                }
            }

            this.fields = [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "img", label: "", thClass: 'thead-themed text-center', tdClass: 'text-center' },
                { key: "name", label: this.$i18n.t('table.header.customer'), thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "lastVisit", label: this.$i18n.t('table.header.last_visit'), thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "bday", label: this.$i18n.t('table.header.birthday'), thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "membership", label: this.$i18n.t('table.header.membership'), thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "gallery", label: this.$i18n.t('table.header.gallery'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center' },
            ]

            if (this.selectedTabView === 'delete') {
                this.memberFiltered = deleted

                this.fields = [
                    { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                    { key: "deleteDate", label: "Date", thClass: 'thead-themed text-center', tdClass: 'text-center' },
                    // { key: "outlet", label: "Outlet", thClass: 'thead-themed text-center', tdClass: 'text-center' },
                    { key: "memberName", label: "Name", thClass: 'thead-themed text-center', tdClass: 'text-center' },
                    { key: "memberContact", label: "Name", thClass: 'thead-themed text-center', tdClass: 'text-center' },
                ]
            } else if (this.selectedTabView === 'hidden') {
                this.memberFiltered = hidden

                this.fields.push(
                    { key: "hiddenDate", label: "Hidden Date", thClass: 'thead-themed align-middle', tdClass: 'align-middle' }
                )
            } else {
                this.memberFiltered = active
            }

            this.setExportData(this.memberFiltered)

            this.totalEntries = this.memberFiltered.length
            this.handlePagination()
            this.showSpinner = false;
        },
        filterMember(record) {
            if (this.selectedVip !== 'all' && !record[this.selectedVip]) {
                return true
            }

            let now = moment()

            record['lastSale'] = record['lastSale'] || {}
            if (this.selectedVisit.id === "one") {
                let lastSaleStart = moment(now).subtract(1, 'month').startOf('day').unix()
                let lastSaleStop = moment(now).endOf('day').unix()
                if (record['lastSale']['salesDate'] < lastSaleStart) {
                    return true
                }
                if (record['lastSale']['salesDate'] > lastSaleStop) {
                    return true
                }
            } else if (this.selectedVisit.id === "three") {
                let lastSaleStart = moment(now).subtract(3, 'month').startOf('day').unix()
                let lastSaleStop = moment(now).subtract(1, 'month').endOf('day').unix()
                if (record['lastSale']['salesDate'] < lastSaleStart) {
                    return true
                }
                if (record['lastSale']['salesDate'] > lastSaleStop) {
                    return true
                }
            } else if (this.selectedVisit.id === "six") {
                let lastSaleStart = moment(now).subtract(3, 'month').startOf('day').unix()
                let lastSaleStop = moment(now).subtract(3, 'month').endOf('day').unix()
                if (record['lastSale']['salesDate'] < lastSaleStart) {
                    return true
                }
                if (record['lastSale']['salesDate'] > lastSaleStop) {
                    return true
                }
            } else if (this.selectedVisit.id === "more") {
                let lastSaleStop = moment(now).subtract(6, 'month').endOf('day').unix()
                if (record['lastSale']['salesDate'] > lastSaleStop) {
                    return true
                }
            }

            if (this.selectedBday.id === 'today') {
                if (!record['dob'].includes(moment(now).format('-MM-DD'))) {
                    return true
                }
            } else if (this.selectedBday.id === 'last') {
                if (!record['dob'].includes(moment(now).subtract(1, 'month').format('-MM-'))) {
                    return true
                }
            } else if (this.selectedBday.id === 'this') {
                if (!record['dob'].includes(moment(now).format('-MM-'))) {
                    return true
                }
            } else if (this.selectedBday.id === 'next') {
                if (!record['dob'].includes(moment(now).add(1, 'month').format('-MM-'))) {
                    return true
                }

            }

            if (this.searchMember) {
                let keyword = this.searchMember.toLowerCase()
                let name = (record['name'] || '').toLowerCase()
                let mobile = (record['mobile'] || '').toLowerCase()
                if (!name.includes(keyword) && !mobile.includes(keyword)) {
                    return true
                }
            }
        },

        async loadMemberListHidden() {
            let querystring = this.selectedVip == "all" ? "" : "&" + this.selectedVip + "=1";

            let now = moment()

            switch (this.selectedVisit.id) {
                case "one":
                    querystring += `&lastSaleStart=${moment(now).subtract(1, 'month').startOf('day').unix()}&lastSaleStop=${moment(now).endOf('day').unix()}`
                    break;
                case "three":
                    querystring += `&lastSaleStart=${moment(now).subtract(3, 'month').startOf('day').unix()}&lastSaleStop=${moment(now).subtract(1, 'month').endOf('day').unix()}`
                    break;
                case "six":
                    querystring += `&lastSaleStart=${moment(now).subtract(6, 'month').startOf('day').unix()}&lastSaleStop=${moment(now).subtract(3, 'month').endOf('day').unix()}`
                    break;
                case "more":
                    querystring += `&lastSaleStart=0&lastSaleStop=${moment(now).subtract(6, 'month').endOf('day').unix()}`
                    break;
            }

            switch (this.selectedBday.id) {
                case "today":
                    querystring += `&dobMonth=${moment(now).format('MM')}&dobDay=${moment(now).format('DD')}`
                    break;
                case "last":
                    querystring += `&dobMonth=${moment(now).subtract(1, 'month').format('MM')}`
                    break;
                case "this":
                    querystring += `&dobMonth=${moment(now).format('MM')}`
                    break;
                case "next":
                    querystring += `&dobMonth=${moment(now).add(1, 'month').format('MM')}`
                    break;
            }

            querystring += this.searchMember ? "&search=" + this.searchMember : "";
            querystring += this.selectedTabView === "hidden" ? "&hiddenMember=1" : "";

            var result = await this.getMemberList("?page=" + this.page + querystring)
            var retData = setReturnData(result.result, result.count, this.page)
            this.memberLists = retData.result;
            this.totalEntries = result.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;

            this.showSpinner = false;

            this.getMemberList("?" + querystring, true)
        },
        async getMemberList(querystring, isExport) {
            let $vm = this
            let url = this.$api.BIZ_MEMBER + querystring

            var result = {}
            await $vm.$axios({
                method: 'get',
                url: url,
                baseURL: this.$api.API_ENDPOINT_MEMBER,
                headers: { token: $vm.$session.get('token') }
            })
                .then((response) => {
                    if (isExport) {
                        this.memberExportData = response.data['members']
                        this.setExportData(this.memberExportData)
                        return
                    }

                    result = { result: response.data['members'] }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
            return result
        },

        setExportData(members) {
            this.exportFields = {}
            this.exportFields["#"] = "index";
            this.exportFields[(this.$i18n.t('table.header.name')).toUpperCase()] = "name"
            this.exportFields[(this.$i18n.t('table.header.contact')).toUpperCase()] = "contact"
            this.exportFields[(this.$i18n.t('table.header.birthday')).toUpperCase()] = "birthday"
            this.exportFields[this.vipTabs[1].text] = this.vipTabs[1].text;
            this.exportFields[this.vipTabs[2].text] = this.vipTabs[2].text;
            this.exportFields[this.vipTabs[3].text] = this.vipTabs[3].text;
            this.exportFields['Last Visit'] = "lastVisitDate"

            if (this.selectedTabView === 'delete') {
                this.exportFields = {}
                this.exportFields["#"] = "index";
                this.exportFields['Date'] = "deleteDate"
                this.exportFields['Name'] = "name"
                this.exportFields['Contact'] = "contact"
            } else if (this.selectedTabView === 'hidden') {
                this.exportFields['Hidden Date'] = "hiddenDate"
            }

            this.exportData = [];
            for (var i = 0; i < members.length; i++) {
                var data = {}
                data["index"] = i + 1;
                data["name"] = members[i].name
                data["contact"] = "+" + (members[i].mobile).toString()
                data["birthday"] = this.getMemberDob(members[i].dob)
                data[this.vipTabs[1].text] = members[i].vip == '0' ? "-" : "Yes"
                data[this.vipTabs[2].text] = members[i].vvip == '0' ? "-" : "Yes"
                data[this.vipTabs[3].text] = members[i].vvvip == '0' ? "-" : "Yes"

                data["lastVisitDate"] = this.getMemberLastVisit(members[i].lastSale)
                data["hiddenDate"] = this.getMemberDateTime(members[i].hideDate)
                data["deleteDate"] = this.getMemberDateTime(members[i].deleteDate)

                this.exportData.push(data)
            }

            var type = this.$i18n.messages[this.$i18n.locale].tab.memberTabLists.filter(obj => obj.id == this.selectedTabView)
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.my_salon_member`) + " (" + type[0].text + ")"
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), " "];
            this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV
        },

        editGallery(item) {
            this.$refs.memberGallery.editMemberGallery(item)
        },

        onMemberDetailClick(item) {
            this.memberDetailModal = true
            this.memberDetailSave = false
            this.memberDetail = JSON.parse(JSON.stringify(item))
        },
        onMemberDetailNameChange() {
            this.memberDetailDisableSave = (!this.memberDetail.name || document.getElementById('err').innerHTML) ? true : false
        },
        onMemberDetailPhoneChange() {
            var err = contactValidation(this.memberDetail.mobile);

            if (err) {
                document.getElementById('err').innerHTML = this.$i18n.t('message.contact_validation.phone_number', {
                    'error': this.$i18n.t(`message.contact_validation.error.${err}`)
                })
                this.memberDetailDisableSave = true
            } else {
                document.getElementById('err').innerHTML = ''
                this.memberDetailDisableSave = !this.memberDetail.name
            }
        },
        onMemberDetailModalSave() {
            this.$axios({
                method: 'post',
                url: `https://member.tunai.io/business/member/${this.memberDetail.memberID}/update`,
                headers: { token: this.$util.getSessionToken() },
                data: {
                    name: this.memberDetail.name,
                    mobile: this.memberDetail.mobile,
                },
            })
                .then((response) => {
                    this.$parent.$parent.setModal(this, false, true, `Member detail updated successfully`);
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    } else {
                        this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
                    }
                })
        },
        closeModal() {
            this.memberDetailModal = false
            this.loadMemberList()
        },

        confirmDeleteMember() {
            if(confirm(`Permanently DELETE member ${this.memberDetail.mobile} (${this.memberDetail.name}) and all related data from system. You CAN'T undo this action.`)) {
                this.$axios({
                    method: 'post',
                    url: `https://member.tunai.io/business/member/${this.memberDetail.memberID}/delete`,
                    headers: { token: this.$util.getSessionToken() },
                })
                .then((response) => {
                    this.$parent.$parent.setModal(this, false, true, `Member deleted successfully`);
                    this.memberDetailModal = false
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    } else {
                        this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
                    }
                })
            }
        },
    },
    async mounted() {
        let $vm = this;
        await $vm.getMembershipTags();

        // let dbName = this.$store.state.userName + "_member_list";
        // this.db = await idbOpen(dbName, "member_list");

        $vm.selectedVisit = $vm.lastVisits[0]
        $vm.selectedBday = $vm.birthdays[0]
        $vm.loadMemberList();
    }
}
</script>
<style scoped>
.link,
.nav-link {
    cursor: pointer;
}

.show {
    display: block;
}

.modal-body {
    max-height: 80vh;
    overflow-y: auto;
}

.hoverColumm {
    min-height: 1px;
}

.hoverColumn:hover {
    box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}

.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>